import axios from 'axios'
import { useLogger } from '@booksy-com/vue-tools'

const logger = useLogger('axios')

axios.defaults.timeout = 10000
axios.interceptors.request.use(
  config => {
    logger.debug(`${config.method} ${config.url}`)
    return config
  },
  error => {
    // do NOT pass error to logger; sometimes it's huge & may "kill" application
    logger.error(error.message)
    return Promise.reject(error)
  }
)

export default axios
